export default "__VITE_ASSET__BH4LzWjs__"